/**
 * Accessory rail ATC: flash Added, then keep the pill distinct.
 */
(function (root) {
  'use strict';

  var FLASH_MS = 1200;

  var PREORDER_PROP = '_preorder';

  function isPreorderControl(el) {
    if (!el || !el.getAttribute) return false;
    return el.getAttribute('data-preorder') === 'true' || el.getAttribute('data-backorder') === 'true';
  }

  function stampPreorderProps(props, isPreorder) {
    var next = props && typeof props === 'object' ? props : {};
    if (isPreorder) next[PREORDER_PROP] = 'true';
    return next;
  }

  function stampPreorderOnItem(item, el) {
    if (!item) return item;
    if (!isPreorderControl(el)) return item;
    item.properties = stampPreorderProps(item.properties, true);
    return item;
  }

  function syncFormPreorderProp(form, isPreorder) {
    if (!form) return;
    var input = form.querySelector('[data-d1-preorder-prop]');
    if (!input) return;
    input.disabled = !isPreorder;
  }

  function idleLabelOf(btn) {
    if (!btn) return '+ Add';
    if (btn.dataset.idleLabel) return btn.dataset.idleLabel;
    var text = String(btn.textContent || '').replace(/\s+/g, ' ').trim();
    if (text && text !== 'Adding…' && text !== 'Added' && text !== 'Error' && text.indexOf('✓') !== 0) {
      btn.dataset.idleLabel = text;
      return text;
    }
    return btn.dataset.preorder === 'true' ? 'Pre-Order' : '+ Add';
  }

  function restLabel(idle) {
    return String(idle || 'Add').replace(/^\+\s*/, '');
  }

  function markInCart(btn, options) {
    options = options || {};
    if (!btn || btn.tagName !== 'BUTTON' || !btn.dataset.variantId) return btn;
    if (btn.classList.contains('card__atc-btn--sold-out')) return btn;

    var idle = idleLabelOf(btn);
    var later = options.later || function (fn, ms) { return setTimeout(fn, ms); };
    var flashMs = options.flashMs == null ? FLASH_MS : options.flashMs;

    btn.classList.add('card__atc-btn--in-cart');
    btn.setAttribute('aria-label', 'Added to cart');

    if (options.justAdded) {
      btn.classList.add('is-just-added');
      btn.textContent = 'Added';
      if (btn._d1AddedTimer) clearTimeout(btn._d1AddedTimer);
      btn._d1AddedTimer = later(function () {
        btn.classList.remove('is-just-added');
        btn.textContent = '\u2713 ' + restLabel(idle);
        btn.disabled = false;
        btn._d1AddedTimer = null;
      }, flashMs);
      return btn;
    }

    btn.classList.remove('is-just-added');
    btn.textContent = '\u2713 ' + restLabel(idle);
    return btn;
  }

  function variantIdsOf(btn) {
    if (!btn) return [];
    var raw =
      (btn.getAttribute && btn.getAttribute('data-variant-ids')) ||
      btn.dataset.variantIds ||
      btn.dataset.variantId ||
      '';
    return String(raw)
      .split(',')
      .map(function (part) {
        return parseInt(String(part).trim(), 10);
      })
      .filter(function (id) {
        return id > 0;
      });
  }

  function itemsFromButton(btn) {
    var ids = variantIdsOf(btn);
    var combo = ids.length > 1;
    return ids.map(function (id, index) {
      var item = { id: id, quantity: 1 };
      if (btn.dataset.productId) item.product_id = parseInt(btn.dataset.productId, 10);
      stampPreorderOnItem(item, btn);
      if (combo) {
        item.properties = item.properties || {};
        item.properties.Activation =
          index === 0 ? 'Activate this 2-Year plan first' : 'Then activate this 1-Year plan';
      }
      return item;
    });
  }

  function syncFromCart(root, cart) {
    if (!root) return [];
    var items = cart && cart.items ? cart.items : [];
    var ids = {};
    for (var i = 0; i < items.length; i += 1) {
      ids[String(items[i].variant_id)] = true;
    }
    var marked = [];
    var buttons = root.querySelectorAll('.card__atc-btn[data-variant-id]');
    for (var j = 0; j < buttons.length; j += 1) {
      var btn = buttons[j];
      var needed = variantIdsOf(btn);
      if (!needed.length) continue;
      var allInCart = needed.every(function (id) {
        return ids[String(id)];
      });
      if (!allInCart) continue;
      markInCart(btn);
      marked.push(btn);
    }
    return marked;
  }

  function syncAllForms() {
    if (!root.document || typeof root.document.querySelectorAll !== 'function') return;
    var forms = root.document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i += 1) {
      var form = forms[i];
      var submit = form.querySelector('[data-d1-main-submit], [name="add"]');
      syncFormPreorderProp(form, isPreorderControl(submit));
    }
  }

  if (root.document) {
    if (root.document.readyState === 'loading') {
      root.document.addEventListener('DOMContentLoaded', syncAllForms);
    } else {
      syncAllForms();
    }
  }

  root.D1AccessoryAtc = {
    FLASH_MS: FLASH_MS,
    PREORDER_PROP: PREORDER_PROP,
    isPreorderControl: isPreorderControl,
    stampPreorderProps: stampPreorderProps,
    stampPreorderOnItem: stampPreorderOnItem,
    syncFormPreorderProp: syncFormPreorderProp,
    idleLabelOf: idleLabelOf,
    restLabel: restLabel,
    markInCart: markInCart,
    variantIdsOf: variantIdsOf,
    itemsFromButton: itemsFromButton,
    syncFromCart: syncFromCart,
  };
})(typeof window !== 'undefined' ? window : globalThis);
